import { render } from "./ThemesEdit.vue?vue&type=template&id=201f2199"
import script from "./ThemesEdit.vue?vue&type=script&lang=js"
export * from "./ThemesEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__